require('../module/tips');
require('../module/share');
require('../module/popup');
require('../module/obtain');
require('../module/BrowserType');
var copy=require('../module/copy');

copy();
BrowserType();

$(function(){
    $(".tab span").click(function(){
        var index=$(this).index();
        $(".rule_list").hide().eq(index).show()
    })
});







